<template>
  <component
    :is="tag"
    class="button"
    :class="modifiers"
    v-bind="attributes"
    v-on="$listeners"
  >
    <slot>
      <span class="button__inner">
        <slot name="before" />
        <span
          v-if="text"
          v-html="text"
          class="button__text"
        />
        <slot name="after" />
      </span>
    </slot>
  </component>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    tag: {
      type: String,
      default: 'button',
    },
    text: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    view: {
      type: String,
      default: 'action',
    },
    theme: {
      type: String,
      default: 'primary',
    },
    action: {
      type: Function,
      default: null,
    },
  },
  computed: {
    attributes() {
      const attributes = {};
      if (this.tag === 'button') {
        attributes.type = 'button';
      }
      return { ...attributes, ...this.$attrs };
    },
    modifiers() {
      return {
        [`button_theme_${this.theme}`]: Boolean(this.theme),
        [`button_view_${this.view}`]: Boolean(this.view),
        [`button_size_${this.size}`]: Boolean(this.size),
      };
    },
  },
};
</script>

<style lang="stylus">
.button
  display inline-flex
  align-items center
  justify-content center
  vertical-align top
  font-family inherit
  text-decoration none
  font-size 1em
  text-align center
  font-weight 700
  letter-spacing .01em
  line-height 1
  max-width 100%
  padding 0
  border 0
  background none
  outline none
  border-radius 0

  &_view_action
    height 3.4em
    padding 0 1.7em
    background currentColor
    border-radius 0.2em
    & ^[0]__text
      color $c_light

  &_view_outlined
    height 3.4em
    padding 0 1.7em
    border solid 0.125em currentColor
    border-radius 0.2em

  &_theme_primary
    &^[0]_view_action
      color $c_primary
      &:not([disabled]):hover
        color darken(@color, 10%)
    &^[0]_view_outlined
      border-color $c_border
      color $c_primary
      &:not([disabled]):hover
        background-color #fff
        color @color

  &_theme_secondary
    &^[0]_view_action
      background $c_secondary linear-gradient(180deg, alpha(#F18705, 80%), alpha(#F18705, 0))

  &_theme_light
    &^[0]_view_action
      color alpha($c_light, 20%)
      &:not([disabled]):hover
        color alpha($c_light, 30%)
    &^[0]_view_outlined
      border-color alpha($c_light, 20%)
      color $c_light
      &:not([disabled]):hover
        border-color alpha($c_light, 30%)

  &[disabled]
    color $c_dim
    & ^[0]__text
      color $c_text_dim
</style>
